import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import snail from "../assets/snail.svg";
import errorbg from "../assets/errorbg.png";

const NotFound = () => {
  return (
    <div>
      <div className="herobg text-white position-relative">
        <Header />
        <div className="container error-hero" style={{ height: "100vh" }}>
                  <div className="error-content d-flex align-items-center justify-content-between">
            <div className="w-40">
              <img src={snail} alt="error" />
            </div>
            <div className="">
              <h1 style={{fontSize: "120px"}} className="text-white mb-25 lh-small">Error 404</h1>
              <p className="font-medium">Oops!!! Seems like you are lost fam</p>
              <Link className="font-medium" to="/">Go Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
